import React from 'react'
import NotificationBuilderAside from '../../../components/notification-builder/elements/notification-builder-aside'
import NotificationBuilderPreview from '../../../components/notification-builder/elements/notification-builder-preview'
import NotificationBuilderMain from '../../../components/notification-builder/elements/notification-builder-main'
import NotificationVariantBuilder from '../../../components/notification-builder/elements/notification-variant-builder'
import NotificationCatalogItemOptions from '../../../components/notification-builder/elements/notification-catalog-item-options'
import { noop } from '../../../_utils/utils'
import type { CatalogStrategy } from './types'
import { NotificationBuilderMacroProps } from '../../../components/notification-builder/interfaces/notification-builder-state.interface'

export type NotificationBuilderContentProps = {
    domain: any
    builder: any
    variants: any[]
    dispatchChanges: (action: any) => void
    onVariantChange: (variant: any, idx: number) => void
    previewOptions: any
    onPreviewRequest: (type: any) => void | Promise<void>
    // Catalog strategy
    isCatalogItemNotification: boolean
    catalogItemPickStrategyOptions: CatalogStrategy[]
    selectedCatalogItemPickStrategy?: CatalogStrategy
    onCatalogStrategyChange: (strategy: CatalogStrategy) => void
    macroProps?: NotificationBuilderMacroProps
}

const NotificationBuilderContent: React.FC<NotificationBuilderContentProps> = (props) => {
    const {
        domain,
        builder,
        variants,
        dispatchChanges,
        onVariantChange,
        previewOptions,
        onPreviewRequest,
        isCatalogItemNotification,
        catalogItemPickStrategyOptions,
        selectedCatalogItemPickStrategy,
        onCatalogStrategyChange,
        macroProps,
    } = props

    const activeVariant = variants[builder.selectedVariantIdx]

    return (
        <>
            <NotificationBuilderAside>
                <NotificationBuilderPreview
                    level="domain"
                    levelId={domain.id}
                    loading={builder.loading}
                    domain={domain}
                    source={activeVariant}
                    onPreviewRequest={onPreviewRequest}
                    options={previewOptions}
                />
            </NotificationBuilderAside>

            <NotificationBuilderMain>
                {isCatalogItemNotification && (
                    <NotificationCatalogItemOptions
                        loading={builder.loading}
                        options={(catalogItemPickStrategyOptions ?? []) as any}
                        selectedStrategy={selectedCatalogItemPickStrategy as any}
                        onChange={(strategy) => onCatalogStrategyChange(strategy as any)}
                    />
                )}

                <NotificationVariantBuilder
                    domain={domain}
                    builder={builder}
                    id={builder.selectedVariantIdx}
                    variant={activeVariant}
                    dispatchChanges={dispatchChanges}
                    onChange={onVariantChange}
                    onSubmit={noop}
                    hideSubmit={true}
                    hideDelivery={true}
                    hideImageMacroToggle={!macroProps?.imageMacroProps}
                    macroCategories={macroProps?.categories}
                    imageMacroToggleLabel={macroProps?.imageMacroProps?.label}
                    imageMacroValue={macroProps?.imageMacroProps?.tag}
                    imageMacroIcon={macroProps?.imageMacroProps?.icon}
                />
            </NotificationBuilderMain>
        </>
    )
}

export default NotificationBuilderContent
